import { memo, type FunctionComponent } from 'react';
// local imports
import useStatusPoller from '../hooks/useStatusPoller';

type DataStatusPollerProps = {
  readonly jobId?: number | null;
}

const DataStatusPoller: FunctionComponent<DataStatusPollerProps> = ({
  jobId
}) => {
  useStatusPoller(jobId || null);
  return null;
};

export default memo(DataStatusPoller);
